import { Box, Stack } from "@mui/material";
import { subHours } from "date-fns";
import { useMemo, useState } from "react";
import { Form, FormDataConsumer, required, SaveButton } from "react-admin";
import { FieldValues } from "react-hook-form";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import { SiteContryEnum } from "shared/enums/globalEnums";
import GrafanaTelemetryChart from "./GrafanaTelemetryChart";

type GroupTelemetryProps = {
  edrParams: Record<string, string | number>;
};

const GroupTelemetry = ({ edrParams }: GroupTelemetryProps) => {
  const [range, setRange] = useState<{ from: Date; to: Date }>({ from: subHours(new Date(), 1), to: new Date() });

  const params = useMemo(
    () => ({
      ...edrParams,
      "view-panel": 3,
      panelId: 3,
      from: range.from.getTime(),
      to: range.to.getTime(),
    }),
    [edrParams, range],
  );

  const handleSubmit = ({ from, to }: FieldValues) => {
    setRange({ from: new Date(from), to: new Date(to) });
  };

  return (
    <Box width="100%">
      <Form onSubmit={handleSubmit}>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: "100%" }}>
          <FormDataConsumer>
            {({ formData }) => {
              return (
                <>
                  <CustomDateTimeInput
                    source="from"
                    defaultValue={range.from}
                    validate={required()}
                    maxDateTime={new Date(formData.to)}
                  />
                  <CustomDateTimeInput
                    source="to"
                    defaultValue={range.to}
                    validate={required()}
                    maxDateTime={new Date()}
                    minDateTime={new Date(formData.from)}
                  />
                </>
              );
            }}
          </FormDataConsumer>
          <SaveButton size="large" sx={{ width: 400, alignSelf: "flex-start", top: "4px" }} label="Apply Dates" />
        </Stack>
      </Form>

      <GrafanaTelemetryChart country={SiteContryEnum.France} params={params} sx={{ mt: 2 }} />
    </Box>
  );
};

export default GroupTelemetry;
